import React from "react";
import { Link } from "react-router-dom";
import { UserCheck, ShieldCheck, Clock, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import QuoteCalculator from "../components/QuoteCalculator";

export default function PricingCalculator() {
  const perks = [
    { icon: UserCheck, t: "Tailored to you", d: "Pricing based on your actual business profile — not a generic list." },
    { icon: ShieldCheck, t: "Private & confidential", d: "Your details go directly to our consultants and stay private." },
    { icon: Clock, t: "No obligation", d: "It's simply a starting point for a conversation about your goals." },
  ];

  return (
    <div>
      <PageHeader
        title="Request a Tailored Quote"
        crumb="Request a Quote"
        subtitle="Share a few details about your business and our specialists will prepare pricing tailored specifically to your B-BBEE requirements."
      />

      {/* Perks */}
      <section className="py-10 bg-[#F6F7F9]">
        <div className="container-x grid sm:grid-cols-3 gap-5">
          {perks.map((p, idx) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.t} delay={idx * 80}>
                <div className="flex gap-3 items-start bg-white rounded-xl border border-slate-100 p-5 h-full">
                  <div className="w-10 h-10 rounded-lg bg-[#0B1F3A] grid place-items-center text-[#D4AF37] shrink-0">
                    <Icon size={20} />
                  </div>
                  <div>
                    <h4 className="font-head font-semibold text-[#0B1F3A] text-[15px]">{p.t}</h4>
                    <p className="text-sm text-slate-500">{p.d}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* Quote request form */}
      <section className="py-16">
        <div className="container-x">
          <QuoteCalculator />
        </div>
      </section>

      {/* CTA */}
      <section className="pb-20">
        <div className="container-x text-center">
          <p className="text-slate-500">Prefer to talk it through first?</p>
          <Link to="/contact" className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-lg mt-4">
            Book a consultation <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
